import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-aboutme',
  templateUrl: './aboutme.component.html',
  styleUrls: ['./aboutme.component.css'],
})
export class AboutmeComponent implements OnInit {
  constructor(private router: Router, private titleService: Title) {}

  title = 'About - Rahil Hastu';

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    let title = <HTMLElement[]>(<any>document.querySelectorAll('.title span'));

    setTimeout(() => {
      let delay = 0;
      title.forEach((spanEle) => {
        spanEle.style.animation = `comeout 1s ease ${delay}s forwards`;
        delay += 0.05;
      });
    }, 1000);

    title.forEach((spanTag) => {
      spanTag.addEventListener('mouseover', () => {
        spanTag.style.opacity = '1';
        spanTag.style.animation = '';
        spanTag.classList.toggle('bounce');
      });
    });
  }
}
